"use client";

import { useContext } from "react";
import { SessionContext } from "@/lib/auth/SessionContextProvider";
import useStoreKeys from "@/hooks/useStoreKeys";
import { B3Role } from "@/lib/bigcommerce-b2b/types";
import { getAccountLinks } from "@/utils/account-links-utils";
import * as Dialog from "@radix-ui/react-dialog";
import clsx from "clsx";
import Link from "next/link";
import styles from "./AccountNav.module.scss";

interface AccountNavProps {
	isOpen: boolean;
	setIsOpen: (isOpen: boolean) => void;
	role?: B3Role;
	url: string;
	accountAreaConfig: any;
}

const AccountNav = ({
	isOpen = false,
	role,
	url,
	setIsOpen,
	accountAreaConfig,
}: AccountNavProps) => {
	const { store, lang } = useStoreKeys();
	const session = useContext(SessionContext);

	if (role === undefined) {
		return null;
	}

	return (
		<Dialog.Root open={isOpen}>
			<Dialog.Overlay
				className={styles.overlay}
				onClick={() => setIsOpen(false)}
			/>
			<Dialog.Content className={styles.nav}>
				<div className={styles.items}>
					{getAccountLinks(
						session?.session?.rolePermissions,
						accountAreaConfig,
						{
							store,
							lang,
						},
					).map((link) => {
						const isActive = url.endsWith(link.link.href);

						return (
							<Link
								key={link.link.href}
								href={link.link.href}
								className={clsx(styles.navItem, { [styles.active]: isActive })}
							>
								{link.link.text}
							</Link>
						);
					})}
				</div>
			</Dialog.Content>
		</Dialog.Root>
	);
};

export default AccountNav;
